type Params = {
  tenant?: string;
  domain?: string;
  marketingUrl?: string | null;
  tripId?: number | string | null;
  tripName?: string | null;
  country?: string | null;
};

const MAX_NAME_SLUG_LENGTH = 80;

const slugify = (value?: string | null, maxLength?: number): string => {
  let slug = (value ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  if (maxLength && slug.length > maxLength) {
    slug = slug.slice(0, maxLength).replace(/-+$/g, '');
  }

  return slug;
};

const encodeTripId = (tripId?: number | string | null): string | null => {
  if (tripId === null || tripId === undefined) {
    return null;
  }

  const id = String(tripId).trim();

  return /^\d+$/.test(id) ? btoa(id) : null;
};

/**
 * URL for the "Go to Website" link of the expired booking modal.
 * DealsAway links to the trip page on the website
 * (/destination/<country>/trip/<base64 id>/<name>), where only the encoded id
 * selects the trip, and falls back to the home page without a valid trip id.
 * GWAT goes to the marketing url and falls back to the home page.
 */
const getWebsiteUrl = ({
  tenant,
  domain,
  marketingUrl,
  tripId,
  tripName,
  country,
}: Params): string => {
  const homeUrl = `https://${domain}/`;

  if (tenant === 'dealsaway') {
    const encodedId = encodeTripId(tripId);

    if (!encodedId) {
      return homeUrl;
    }

    const countrySlug = slugify(country) || 'trip';
    const nameSlug = slugify(tripName, MAX_NAME_SLUG_LENGTH) || 'trip';

    return `https://${domain}/destination/${countrySlug}/trip/${encodedId}/${nameSlug}`;
  }

  const path = marketingUrl?.trim().replace(/^\/+/, '');

  return path ? `https://${domain}/${path}` : homeUrl;
};

export { getWebsiteUrl };
